import React, { useState } from "react";
import TitreEtape from "./TitreEtape";
import { confirmationValide } from "./effacementDonnees";

const ConfirmationEffacement = ({ email, envoiEnCours, onEffacer }) => {
  const [saisie, setSaisie] = useState("");
  const valide = confirmationValide(saisie, email);

  const soumettre = (e) => {
    e.preventDefault();
    if (valide && !envoiEnCours) onEffacer();
  };

  return (
    <section className="effacement__carte effacement__carte--danger" aria-labelledby="titre-confirmation">
      <header className="effacement__entete">
        <TitreEtape numero={3} id="titre-confirmation">
          Confirmer l'effacement
        </TitreEtape>
      </header>
      <p className="mb-3">
        L'effacement est <strong>définitif</strong> : tout ce qui est listé ci-dessus disparaît, chez Perceval et chez
        les partenaires, sans restauration possible.
      </p>
      <form onSubmit={soumettre} noValidate>
        <label className="effacement__libelle" htmlFor="confirmation-effacement">
          Pour confirmer, saisissez l'adresse <strong>{email}</strong>
        </label>
        <div className="effacement__formulaire">
          <input
            id="confirmation-effacement"
            type="email"
            inputMode="email"
            className="form-control"
            autoComplete="off"
            spellCheck={false}
            value={saisie}
            onChange={(e) => setSaisie(e.target.value)}
            aria-describedby="aide-confirmation"
          />
          <button type="submit" className="btn btn-danger" disabled={!valide || envoiEnCours}>
            <i className={`fa ${envoiEnCours ? "fa-spinner fa-spin" : "fa-user-slash"} mr-2`} aria-hidden="true" />
            Effacer définitivement
          </button>
        </div>
        <p className="effacement__aide" id="aide-confirmation">
          Le bouton s'active quand l'adresse saisie correspond.
        </p>
      </form>
    </section>
  );
};

export default ConfirmationEffacement;
